// Match only whole tokens. String.split also inserts inner capture groups, which can duplicate IDs.
export function tokenizeMessage(text,pattern){
 const parts=[];let at=0;
 for(const match of text.matchAll(pattern)){
  if(match.index>at)parts.push(text.slice(at,match.index));
  parts.push(match[0]);at=match.index+match[0].length;
 }
 if(at<text.length)parts.push(text.slice(at));return parts;
}
